import { Context, createContext } from "react";
import i18next from "i18next";
import type { i18n } from "i18next";

export const I18nContext: Context<i18n> = createContext(i18next);
